import { render } from "./schedules-details.vue?vue&type=template&id=085f1232&scoped=true"
import script from "./schedules-details.vue?vue&type=script&lang=js"
export * from "./schedules-details.vue?vue&type=script&lang=js"

import "./schedules-details.vue?vue&type=style&index=0&id=085f1232&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085f1232"]])

export default __exports__